<div class="mb-2">
  <div class="flex justify-between">
    <h2 class="text-lg font-medium ">{{ title() }}</h2>
    <div>
      <ng-content></ng-content>
    </div>
  </div>
  @if (subtitle()) {
    <p class="text-sm">{{ subtitle() }}</p>
  }
</div>
